import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged, map, pairwise } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { RevShareCompartments, revShareStorageKey } from '..';
import { GroupCompartments, groupStorageKey } from '../../group';
import { GroupData } from '../../../models/GroupData';

export class GroupRevShareListener implements IListener {
  constructor(
    @injectDataCache(groupStorageKey)
    private readonly groupCache: DataCache<GroupCompartments>,
    @injectDataCache(revShareStorageKey)
    private readonly cache: DataCache<RevShareCompartments>,
  ) {}

  start(): Subscription {
    return this.groupCache
      .observe$<GroupData | undefined>('group')
      .pipe(
        map(group => group?.id),
        distinctUntilChanged(),
        pairwise(),
      )
      .subscribe(([previousGroupId]) => {
        if (previousGroupId !== undefined) {
          this.cache.reset('groupRevShareSettings');
        }
      });
  }
}

export class TeamRevShareListener implements IListener {
  constructor(
    @injectSubject(Predicates.TeamAvailablePricebooksInitialized)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(revShareStorageKey)
    private readonly cache: DataCache<RevShareCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('teamRevShareSettings');
      }
    });
  }
}

export class OrgRevShareListener implements IListener {
  constructor(
    @injectSubject(Predicates.OrgAvailablePricebooksInitialized)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(revShareStorageKey)
    private readonly cache: DataCache<RevShareCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('orgRevShareSettings');
      }
    });
  }
}
